import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDividerModule} from '@angular/material/divider';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatExpansionModule} from '@angular/material/expansion';
import { RouterModule, Routes } from '@angular/router';
import { ExpedienteComponent } from './expediente.component';
import {MatListModule} from '@angular/material/list';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
// import { TablaColaboradoresComponent } from './tabla-colaboradores/tabla-colaboradores.component';
import { ExtensionPipe } from './tabla-colaboradores/tabla-colaboradores.pipes';
// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import { TablaColaboradoresComponent } from './tabla-colaboradores/tabla-colaboradores.component';
import {MatSelectModule} from '@angular/material/select';
import { TablaMedicoComponent } from './tabla-medico/tabla-medico.component';
import {InfoCitaDialog} from './tabla-medico/tabla-medico.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { FuseSharedModule } from '@fuse/shared.module';
import {MatCardModule} from '@angular/material/card';
import {MatRadioModule} from '@angular/material/radio';
// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
const routes: Routes = [
  {
    path: 'expedientes',
    component: ExpedienteComponent,
  }
];
@NgModule({
  declarations: [
    ExpedienteComponent,
    TablaColaboradoresComponent,
    ExtensionPipe,
    TablaMedicoComponent,
    InfoCitaDialog
  ],
  imports: [
    RouterModule.forChild(routes),
    MatListModule,
    MatSelectModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    MatDividerModule,
    MatProgressBarModule,
    MatExpansionModule,

    MatCheckboxModule,
    MatInputModule,
    MatStepperModule,
    FuseSharedModule,
    MatCardModule,
    MatRadioModule
  ],entryComponents:[
    InfoCitaDialog
  ],
})
export class ExpedienteModule { }
